/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import * as R from 'ramda';

export const mapFormErrors = (errors, setErrorFn): void =>
  // @ts-ignore
  R.pipe(
    // @ts-ignore
    R.pluck('extensions'),
    // @ts-ignore
    R.prop(0),
    R.omit(['classification', 'code', 'exception']),
    R.toPairs,
    R.map(R.apply(R.objOf)),
    // @ts-ignore
    R.map(item => setErrorFn(R.keys(item)[0], { message: R.values(item)[0] }))
    // @ts-ignore
  )(errors);
